import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-date-picker',
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ReactiveFormsModule
    ],
    templateUrl: './date-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent {
    @Input() label: string = 'Choose a date';
    @Output() changeDateEvent = new EventEmitter<string>();
    @Input() dateControl = new FormControl(new Date());
    onChangeDate(event: any) {
        this.changeDateEvent.emit(event.value);
    }
}
